export default __webpack_public_path__ + "static/media/billPaymentDefault.e1b7fa58.png";